import type { Translatable } from '../../model/Text'
import { AppBox, AppBoxProps } from '../../../../component/common/analog/molecule/AppBox'
import { observer } from 'mobx-react-lite'
import { forwardRef } from 'react'
import { localTranslate } from '../../model/Translate'

export type TranslatableBoxProps = AppBoxProps & {
  textValue?: Translatable
}

const TranslatableBoxBase = forwardRef<unknown, TranslatableBoxProps>((props, ref) => {
  const { textValue, children = null, ...rest } = props

  return (
    <AppBox ref={ref} {...rest}>
      {children || (textValue ? localTranslate(textValue) : null)}
    </AppBox>
  )
})

TranslatableBoxBase.displayName = 'TranslatableBoxBase'

export const TranslatableBox = observer(TranslatableBoxBase)
